import Menu from "devextreme/ui/menu";

/**
 * Works around a DevExtreme bug (present in 22.1.3 and 22.2.15): dxMenu does not clear its hide-submenu
 * timer when the menu is disposed. The magnifier in each grid filter-row cell is a dxMenu, and the filter
 * row is re-rendered whenever columns change (e.g. switching between Internal and Client view), so a timer
 * started by moving the mouse off a magnifier can fire after its submenu is gone and throw
 * "Cannot read properties of null (reading '$content')". Applied once, when this module is imported.
 */
const menuPrototype = (Menu as any)?.prototype;

if (menuPrototype && !menuPrototype.__timSubmenuTimerFix) {
  menuPrototype.__timSubmenuTimerFix = true;

  const hideSubmenuAfterTimeout = menuPrototype._hideSubmenuAfterTimeout;
  if (typeof hideSubmenuAfterTimeout === "function") {
    menuPrototype._hideSubmenuAfterTimeout = function (this: any, ...args: unknown[]) {
      if (this._visibleSubmenu && !this._visibleSubmenu._overlay) {
        this._visibleSubmenu = null;
        return undefined;
      }
      return hideSubmenuAfterTimeout.apply(this, args);
    };
  }

  const dispose = menuPrototype._dispose;
  if (typeof dispose === "function") {
    menuPrototype._dispose = function (this: any, ...args: unknown[]) {
      this._clearTimeouts?.();
      return dispose.apply(this, args);
    };
  }
}

export {};
